import { CandleType } from '@drift/common';
import { twMerge } from 'tailwind-merge';
import useCurrentSettings from '../../hooks/useCurrentSettings';
import Select from '../Inputs/Select';
import Tooltip from '../Tooltip/Tooltip';
import UIHelpTextLink from '../UIHelpTextLink';

const CandleTypeSelector = (props: { isMobile?: boolean }) => {
	const [currentSettings, setCurrentSettings] = useCurrentSettings();

	const currentCandleType = currentSettings?.preferredCandleType;
	const setCurrentCandleType = (newCandleType: CandleType) => {
		setCurrentSettings({
			...currentSettings,
			preferredCandleType: newCandleType,
		});
	};

	return (
		<div
			className={twMerge(
				`flex items-center`,
				props?.isMobile ? 'space-x-4' : 'space-x-2'
			)}
		>
			<Select.Default
				id="CandleTypeSelector"
				onChange={(newSelection) => {
					setCurrentCandleType(newSelection as CandleType);
				}}
				selection={currentCandleType}
				options={[
					{
						value: CandleType.ORACLE_PRICE,
						label: 'Oracle Price',
					},
					{
						value: CandleType.FILL_PRICE,
						label: 'Fill Price',
					},
				]}
			/>
			<Tooltip
				className="text-text-default"
				allowHover
				content={
					<div className="flex flex-col space-y-1">
						<span>
							You can use this selector to switch the chart candles between
							historical oracle and fill prices. Note: triggers attached to
							orders use the oracle price.
						</span>
						<UIHelpTextLink
							href="https://docs.drift.trade/trading/order-types"
							text="Learn More"
						/>
					</div>
				}
			/>
		</div>
	);
};

export default CandleTypeSelector;
